import { default as MuiDialogActions, DialogActionsProps } from '@mui/material/DialogActions'
import * as React from 'react'

const DialogActions: React.FC<React.PropsWithChildren<DialogActionsProps>> = (props) => <MuiDialogActions {...props} />

export default DialogActions
